(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ask-founder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__askFounderTracking) return;
    window.__askFounderTracking = true;

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-ask-founder-track]');
      if (!link) return;

      var method = link.getAttribute('data-ask-founder-track');
      var product = link.getAttribute('data-product') || '';

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'ask_founder_click',
          contact_method: method,
          product_title: product
        });
      } catch (e) {}

      try {
        if (typeof window.fbq === 'function') {
          window.fbq('trackCustom', 'AskFounderClick', {
            contact_method: method,
            content_name: product
          });
        }
      } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
